import React , {useState} from 'react';
import './HeroPackages.css';





const HeroPackages = () => {

  const [slideOne , setSlideOne] = useState(true);
  const [slideTwo , setSlideTwo] = useState(false);
  const [slideThree , setSlideThree] = useState(false);


  const determineslide = (param) => {

      switch(param) {

        case 1:
            setSlideOne(true);
            setSlideTwo(false);
            setSlideThree(false);
            break;

        case 2:
            setSlideOne(false);
            setSlideTwo(true);
            setSlideThree(false);
            break;

        case 3:
            setSlideOne(false);
            setSlideTwo(false);
            setSlideThree(true);
            break;

      }

  }

  return (
    <div className='hero_packages' >

    <div className="main_packages_div">

    <div className="package_single_div">

    <div className="pacakge_image">

    {slideOne && (
      <div className='sliding_single_div' >
      <img src="/images/heroarea/8.jpg" data-aos-delay="0"	data-aos-duration="250" data-aos="zoom-in"  data-aos-easing="ease-in-sine" data-aos-mirror="true" className='hero_package' />



<div className="package_content">
  <h1 className='heroarea_headline w-50' data-aos="fade-right" data-aos-delay="0" data-aos-easing="linear" data-aos-mirror="true" data-aos-duration="250"  >  رحلة سياحية 3D   </h1>
  <p className='main_para mt-2 color-white w-50' data-aos="fade-right" data-aos-delay="0" data-aos-easing="linear" data-aos-mirror="true" data-aos-duration="250" > تتوفر خاصية في موقعنا وهي رحلة سياحية افتراضية ثلاثية الابعاد في مدينة جازان , حيث يمكنك استكشاف معالم المنطقة والتمتع بالمناظر الخلابة
 </p>

  <button className="btn_explore_sm w-30 mt-2" data-aos="fade-left" data-aos-delay="0" data-aos-easing="linear" data-aos-mirror="true" data-aos-duration="250" > أكتشف أكثر </button>
  <div className="sliding_arrow" onClick={() => determineslide(3) } >
        <img src="/images/icons/left-arrow-black.png" alt="" />
      </div>


</div>

    


      </div>
    )}

    {slideTwo && (
      <div className='sliding_single_div' >
      <img src="/images/heroarea/9.jpg" data-aos="zoom-out-left" data-aos-duration="250"   data-aos-easing="ease-in-cubic" data-aos-mirror="true"  className='hero_package' />



<div className="package_content">
  <h1 className='heroarea_headline w-50' data-aos-duration="250" data-aos="fade-right" data-aos-delay="0" data-aos-easing="linear" data-aos-mirror="true"  >  أبرز معالم المنطقة
  </h1>

  <p className='main_para mt-2 color-white w-50' data-aos-duration="250" data-aos="fade-right" data-aos-delay="0" data-aos-easing="linear" data-aos-mirror="true" > أبرز الوجهات و المعالم السياحية تستطيع ان تجدها في موقع بوصلتك , كما يمكنك التفاعل مع المواقع السياحية والمناظر الطبيعية بتقنية الواقع الافتراضي </p>

  <button className="btn_explore_sm w-30 mt-2" data-aos-duration="250" data-aos="fade-left" data-aos-delay="0" data-aos-easing="linear" data-aos-mirror="true" > أكتشف أكثر </button>

  <div className="sliding_arrow" onClick={() => determineslide(3) } >
        <img src="/images/icons/left-arrow-black.png" alt="" />
      </div>

</div>
      </div>
    )}

    {slideThree && (
      <div className='sliding_single_div' >
      <img src="/images/heroarea/10.jpg" data-aos="zoom-out" data-aos-duration="250"   data-aos-easing="ease-in-quad" data-aos-mirror="true" className='hero_package' />



<div className="package_content">
  <h1 className='heroarea_headline w-50' data-aos-duration="250"   data-aos="fade-right" data-aos-delay="10" data-aos-easing="linear" data-aos-mirror="true"  >     أهم ما تحتاجه في سفرك ! </h1>

  <p className='main_para mt-2 color-white w-50' data-aos-duration="250"  data-aos="fade-right" data-aos-delay="10" data-aos-easing="linear" data-aos-mirror="true" > تتوفر خاصية حجوزات للاماكن السياحية والفعاليات الترفيهية عن طريق الموقع الرسمي او الاتكشاف داخل الخريطة </p>

  <button className="btn_explore_sm w-30 mt-2" data-aos-duration="250"  data-aos="fade-left" data-aos-delay="10" data-aos-easing="linear" data-aos-mirror="true" > أكتشف أكثر </button>

  <div className="sliding_arrow" onClick={() => determineslide(1) } >
        <img src="/images/icons/left-arrow-black.png" alt="" />
      </div>

</div>
      </div>
    )}



    <div className="package_slider_images">
 

<img src="/images/heroarea/4-small.jpg" alt="" className="rectangle_package_img package_one" onClick={() => determineslide(1) } />
<img src="/images/heroarea/5-small.jpg" alt="" className="rectangle_package_img package_two" onClick={() => determineslide(2) } />
<img src="/images/heroarea/7-small.jpg" alt="" className="rectangle_package_img package_four" onClick={() => determineslide(3) } />


</div>

      <div className="slding_arrow d-flex-c">
          <img src="/images/icons/left-arrow.png" alt="" className="icon_smaller sliding_btn_package" />
          <img src="/images/icons/right-arrow.png" alt="" className="icon_smaller sliding_btn_package" />
      </div>

</div>



      

    </div>

    </div>

    </div>
  )
}

export default HeroPackages